export const RESET = 'BACKUP_STATUS_LIST_RESET'
export const SET_ITEMS = 'BACKUP_STATUS_LIST_SET_ITEMS'
export const SET_ERROR = 'BACKUP_STATUS_LIST_SET_ERROR'
export const SET_VIEW = 'BACKUP_STATUS_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'BACKUP_STATUS_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/backup_status/list/mutation_types.js